/// <amd-module name="SuiteCommerce.SizeChart.Common.Utils"/>
define("SuiteCommerce.SizeChart.Common.Utils", ["require", "exports", "SuiteCommerce.SizeChart.Common.DependencyProvider"], function (require, exports, DependencyProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.getAbsoluteUrl = function (file, isServices2) {
            if (isServices2 === void 0) { isServices2 = false; }
            return DependencyProvider_1.Utils.getAbsoluteUrl(file, isServices2);
        };
        Utils.translate = function (text) {
            var continuationText = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                continuationText[_i - 1] = arguments[_i];
            }
            return DependencyProvider_1.Utils.translate(text, continuationText);
        };
        Utils.getURLComponent = function (fragment) {
            return fragment
                .replace(/[^a-zA-Z0-9_ -]/g, '')
                .replace(/^ +| +$/g, '')
                .replace(/ /g, '-')
                .toLowerCase();
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
